module.exports = require("./../../_gen/starling/utils/Color");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/utils/Color.js
// module id = 243
// module chunks = 0